export const searchPlaceholder = '{search}';
